import React from 'react';
import { observer } from 'mobx-react';
import { Field } from 'radiance-ui';

import { FormFieldType } from 'jsx/components/formHelper';

import FieldWrapper from '../fieldWrapper';

interface InputFieldProps {
  field: FormFieldType<string | null>;
  type?: string | null;
  inputComponent?: React.ComponentType | null;
  refInput?: React.RefCallback<unknown> | null;
  hideLabel?: boolean;
  autoFocus?: boolean;
  placeholder?: string | null;
  onBlur?: (event: any) => void;
  disabled?: boolean;
  autoComplete?:
    | boolean
    | React.InputHTMLAttributes<HTMLInputElement>['autoComplete'];
}

const InputField: React.FC<InputFieldProps> = ({
  field,
  type = null,
  inputComponent = null,
  refInput = null,
  hideLabel = false,
  autoFocus = false,
  placeholder = null,
  onBlur = null,
  disabled = false,
  autoComplete,
}) => {
  const Input = inputComponent || Field.Input;
  const fieldProps = {
    name: field.name,
    type,
    autoFocus,
    placeholder,
    onBlur,
  };

  const getAutocompleteProp = () => {
    if (autoComplete === true) {
      return { autoComplete: 'on' };
    }

    if (autoComplete === false) {
      // Chrome ignores autocomplete="off". Use any invalid value to work around this
      return { autoComplete: 'none' };
    }

    if (autoComplete === undefined) {
      return {};
    }

    return { autoComplete };
  };

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <FieldWrapper field={field} hideLabel={hideLabel} disabled={disabled}>
      <Input
        ref={refInput}
        {...field.bind(fieldProps)}
        {...getAutocompleteProp()}
      />
    </FieldWrapper>
  );
  /* eslint-enable react/jsx-props-no-spreading  */
};

export default observer(InputField);
